
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/work/generated/ui/shared/outcomes/content-view/jst/outcomeGroup';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, functionType="function", self=this;

function program1(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n  <a href=\"#\" style=\"float:left\" class=\"move_button move_group_button ui-button ui-widget ui-state-default ui-corner-all\" role=\"button\">\n    <span aria-hidden=\"true\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("outcomes.outcome_group")
  },data:data},helper ? helper.call(depth0, "move_abf00365", "Move", options) : helperMissing.call(depth0, "t", "move_abf00365", "Move", options)))
    + "</span>\n    <span class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("outcomes.outcome_group")
  },data:data},helper ? helper.call(depth0, "move_outcome_group_cfa1a505", "Move Outcome Group", options) : helperMissing.call(depth0, "t", "move_outcome_group_cfa1a505", "Move Outcome Group", options)))
    + "</span>\n  </a>\n  <a href=\"#\" style=\"float:left\" class=\"edit_button edit_group_button ui-button ui-widget ui-state-default ui-corner-all\" role=\"button\">\n    <span aria-hidden=\"true\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("outcomes.outcome_group")
  },data:data},helper ? helper.call(depth0, "outcomes.outcome_group.links.edit_outcome_group", "Edit", options) : helperMissing.call(depth0, "t", "outcomes.outcome_group.links.edit_outcome_group", "Edit", options)))
    + "</span>\n    <span class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("outcomes.outcome_group")
  },data:data},helper ? helper.call(depth0, "edit_outcome_group_f82e0210", "Edit Outcome Group", options) : helperMissing.call(depth0, "t", "edit_outcome_group_f82e0210", "Edit Outcome Group", options)))
    + "</span>\n  </a>\n  <a href=\"#\" style=\"float:left\" class=\"delete_button delete_group_button ui-button ui-widget ui-state-default ui-corner-all\" role=\"button\">\n    <span aria-hidden=\"true\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("outcomes.outcome_group")
  },data:data},helper ? helper.call(depth0, "outcomes.outcome_group.links.delete_outcome_group", "Delete", options) : helperMissing.call(depth0, "t", "outcomes.outcome_group.links.delete_outcome_group", "Delete", options)))
    + "</span>\n    <span class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("outcomes.outcome_group")
  },data:data},helper ? helper.call(depth0, "delete_outcome_group_6b399d34", "Delete Outcome Group", options) : helperMissing.call(depth0, "t", "delete_outcome_group_6b399d34", "Delete Outcome Group", options)))
    + "</span>\n  </a>\n";
  return buffer;
  }

  buffer += "<h2 class=\"title\">\n  <i class=\"icon-folder\"></i>\n  ";
  if (helper = helpers.title) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.title); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\n</h2>\n<div class=\"description\">\n  ";
  if (helper = helpers.description) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.description); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n</div>\n\n";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.canManage), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  